import React from "react";

interface IVideoContext {
  seek(timestamp: number): void;
  currentTimestamp: number;
}
export const AudioContext = React.createContext<IVideoContext>({
  seek: (ts: number) => {},
  currentTimestamp: -1,
});

export function useAudioContext() {
  return React.useContext(AudioContext);
}
export default useAudioContext;
